import styled from 'styled-components';
import {
  breakpoint,
  cssColorValue,
  desktopViola,
  Dropdown,
  FormGroup,
  IconHelpCircle,
  mobileViola,
  semanticColors,
  spacer12,
  spacer16,
  spacer32,
  spacer4,
} from '@spotify-internal/encore-web';

export const Content = styled.div`
  min-height: 800px;
`;

export const TitleAndFreshnessContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 0;
  width: 100%;
  align-items: flex-end;
  @media screen and (max-width: ${breakpoint.screenSmMin}) {
    flex-basis: 100%;
    flex-direction: column;
  }
`;

export const DataFreshnessContainer = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
  flex-direction: column;
  @media screen and (max-width: ${breakpoint.screenSmMin}) {
    padding-top: 10px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${spacer32};
`;

export const InputsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
`;

export const StyledWrapper = styled.span`
  a {
    color: ${cssColorValue(semanticColors.textBrightAccent)};
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
  max-width: 608px;
`;

export const StyledDropdown = styled(Dropdown)`
  min-width: 300px;
`;

export const StyledFormGroup = styled(FormGroup)`
  min-width: 300px;
  flex-basis: 49%;
  @media screen and (max-width: ${breakpoint.screenSmMin}) {
    flex-basis: 100%;
  }
`;

export const LoadingIndicatorContainer = styled.div`
  display: flex;
  justify-content: center;
  min-width: 186px;
  padding-top: ${spacer16};
`;

export const DateRangeLabelContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledIconHelpCircle = styled(IconHelpCircle)`
  margin-left: 4px;
`;

type typeStyle = {
  fontSize: string;
  letterSpacing?: string;
  fontWeight?: number;
  textTransform?: any;
};

const responsiveTypeVariant = (
  mobileTypeStyle: typeStyle,
  desktopTypeStyle: typeStyle,
) => ({
  ...mobileTypeStyle,
  fontSize: mobileTypeStyle.fontSize,
  [`@media (min-width: ${breakpoint.screenSmMin})`]: {
    ...desktopTypeStyle,
    fontSize: desktopTypeStyle.fontSize,
  },
});

export const encoreSelectChipStyles = {
  control(base: any) {
    return {
      ...base,
      boxShadow: `inset 0 0 0 1px ${cssColorValue('essentialSubdued')}`,
      minHeight: '48px',
    };
  },

  valueContainer(base: any) {
    return {
      ...base,
      paddingTop: '5.5px',
      paddingBottom: '5.5px',
      paddingLeft: '14px',
      minHeight: '48px',
    };
  },

  indicatorContainer(base: any) {
    return {
      ...base,
      minHeight: '48px',
    };
  },

  multiValue(base: any) {
    return {
      ...base,
      padding: `${spacer4} ${spacer12}`,
      borderRadius: `${spacer32}`,
      cursor: 'pointer',
      transition: 'background-color 0.2s, color 0.2s',
      '&:hover': {
        backgroundColor: `${cssColorValue(
          semanticColors.backgroundTintedHighlight,
        )}`,
      },
    };
  },
  multiValueLabel(base: any) {
    return {
      ...base,
      ...responsiveTypeVariant(mobileViola, desktopViola),
      color: `${cssColorValue(semanticColors.textBase)}`,
    };
  },
  multiValueRemove(base: any) {
    return {
      ...base,
      svg: {
        fill: `${cssColorValue(semanticColors.textBase)}`,
      },
      '&:hover': {
        backgroundColor: 'initial',
      },
    };
  },
};
